export const inboxActiveTab = {
  INBOX: "inbox",
  TODAY: "today",
} as const;
export type InboxActiveTab = (typeof inboxActiveTab)[keyof typeof inboxActiveTab];

export const InboxToggleTitle = {
  OVERDUE: "Overdue",
} as const;

export type InboxToggleTitleType = (typeof InboxToggleTitle)[keyof typeof InboxToggleTitle];
